import axios from 'axios'

export const getBrands = ({ commit }) => {
  commit('setLoading', true);
  axios.get('/api/brands/getBrands')
    .then(response => {
      commit('getBrands', response.data.data)
    })
    // fail
    .catch(e => {
      commit('getBrands', e.response)
    })
    .finally(() => {
      commit('setLoading', false);
    });
}